class Translations {
    constructor() {
        this.translationTriggers = Array.from(
            document.querySelectorAll(".js-translations-trigger")
        );
    }

    handleLanguageChange() {
        this.translationTriggers.forEach(trigger => {
            trigger.addEventListener("click", e => {
                const newTargetLanguage = e.target.dataset.language;
                // Set a cookie with the selected language
                document.cookie = `targetLanguage=${newTargetLanguage}; path=/`;

                // Reload the page after setting the cookie
                location.reload();
            });
        });
    }

    init() {
        this.handleLanguageChange();
    }
}

export default Translations;



// WEBPACK FOOTER //
// ./js/translations.js